import { LAYOUT_CONSTANTS } from "@src/constants";
import { MEDIA_QUERIES } from "@src/constants/media-queries";
import { useMediaQuery } from "@uhg-abyss/web/hooks/useMediaQuery";
import { styled } from "@uhg-abyss/web/tools/styled";
import { Divider } from "@uhg-abyss/web/ui/Divider";
import { PrimaryFilters } from "./PrimaryFilters";
import { SecondaryFilters } from "./SecondaryFilters";

const FiltersContainer = styled("div", {
  position: "relative",
  display: "flex",
  width: "100%",
  alignItems: "center",
  justifyContent: "center",
  boxSizing: "border-box",
  padding: "32px 8px 24px 8px",
  variants: {
    isSmallerTablet: {
      true: {
        padding: "16px",
      },
    },
  },
});

const FiltersInnerContainer = styled("div", {
  display: "flex",
  width: "100%",
  height: "100%",
  maxWidth: LAYOUT_CONSTANTS.maxContentWidth,
  gap: "20px",
  justifyContent: "space-between",
  variants: {
    isSmallerTablet: {
      true: {
        gap: "10px",
      },
    },
    isSmallestMobile: {
      true: {
        gap: "0",
      },
    },
  },
});

export const Filters = () => {
  const isMobile = useMediaQuery(MEDIA_QUERIES.mobileMax);
  const isSmallerTablet = useMediaQuery(MEDIA_QUERIES.smallerTabletMax);
  const isSmallestMobile = useMediaQuery(MEDIA_QUERIES.smallestMobileMax);
  const isTablet = useMediaQuery(MEDIA_QUERIES.tabletMax);
  const isMediumMax = useMediaQuery(MEDIA_QUERIES.mediumMax);
  const isWideTabletMax = useMediaQuery(MEDIA_QUERIES.wideTabletMax);

  return (
    <FiltersContainer data-testid="test-id-filters" isSmallerTablet={isSmallerTablet}>
      <FiltersInnerContainer isSmallerTablet={isSmallerTablet} isSmallestMobile={isSmallestMobile}>
        <PrimaryFilters
          isMobile={isMobile}
          isMediumMax={isMediumMax}
          isSmallerTablet={isSmallerTablet}
          isTablet={isTablet}
          isWideTabletMax={isWideTabletMax}
        />
        <Divider
          orientation="vertical"
          height="100%"
          css={{
            "abyss-divider-root": {
              marginLeft: "0px !important",
              marginRight: "0px !important",
            },
          }}
        />
        <SecondaryFilters
          isMobile={isMobile}
          isTablet={isTablet}
          isMediumMax={isMediumMax}
          isWideTabletMax={isWideTabletMax}
        />
      </FiltersInnerContainer>
    </FiltersContainer>
  );
};
